// The site's name and address in one place. Change them here and every page
// title, the logo, the sitemap and the share previews follow.

export const SITE_NAME = "PDF & Pixel";
export const SITE_DOMAIN = "pdfandpixel.com";
export const SITE_TAGLINE = "Free PDF and image tools, right in your browser";

/** Public address of the site, no trailing slash. NEXT_PUBLIC_SITE_URL
 *  overrides it at build time (e.g. for a staging copy). */
export const siteUrl = (
  process.env.NEXT_PUBLIC_SITE_URL || `https://${SITE_DOMAIN}`
).replace(/\/+$/, "");
